import { render, staticRenderFns } from "./BaseBulkActionMenu.vue?vue&type=template&id=a82584ca"
import script from "./BaseBulkActionMenu.vue?vue&type=script&lang=js"
export * from "./BaseBulkActionMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseBulkActionMenu.vue?vue&type=style&index=0&id=a82584ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports